import { cloneElement } from 'react';
import { ApprovalsIcon, PublishIcon } from 'foundations-assets';
import { UENameToIdMap } from '../../constants/unifiedEventTypeIds';
import ApprovalUnifiedEventSubmittedUserAvatar from './ApprovalUnifiedEventSubmittedUserAvatar';
import { jsx as _jsx } from "react/jsx-runtime";
const iconSize = 16;
export default function ApprovalUnifiedEventIcon(props) {
  const {
    event,
    defaultIcon
  } = props;
  const eventTypeId = event.eventTypeId.innerId;
  if (eventTypeId === UENameToIdMap.UE_APPROVAL_CREATED) {
    return /*#__PURE__*/_jsx(ApprovalUnifiedEventSubmittedUserAvatar, {
      event: event
    });
  }
  if (eventTypeId === UENameToIdMap.UE_APPROVAL_STEP_APPROVED) {
    return /*#__PURE__*/_jsx(ApprovalUnifiedEventSubmittedUserAvatar, {
      event: event
    });
  }
  if (eventTypeId === UENameToIdMap.UE_APPROVAL_CANCELED) {
    return /*#__PURE__*/_jsx(ApprovalUnifiedEventSubmittedUserAvatar, {
      event: event
    });
  }
  if (eventTypeId === UENameToIdMap.UE_APPROVAL_UPDATED) {
    return /*#__PURE__*/_jsx(ApprovalUnifiedEventSubmittedUserAvatar, {
      event: event
    });
  }
  if (eventTypeId === UENameToIdMap.UE_APPROVAL_REJECTED) {
    return /*#__PURE__*/_jsx(ApprovalUnifiedEventSubmittedUserAvatar, {
      event: event
    });
  }
  if (eventTypeId === UENameToIdMap.UE_APPROVAL_APPROVED) {
    return /*#__PURE__*/cloneElement(defaultIcon, {
      color: 'icon-core-subtle',
      backgroundColor: 'border-core-subtle',
      borderColor: 'border-core-subtle',
      size: iconSize,
      icon: ApprovalsIcon
    });
  }
  if (eventTypeId === UENameToIdMap.UE_APPROVAL_CONCLUDED) {
    return /*#__PURE__*/cloneElement(defaultIcon, {
      color: 'icon-core-subtle',
      backgroundColor: 'border-core-subtle',
      borderColor: 'border-core-subtle',
      size: iconSize,
      icon: PublishIcon
    });
  }
  return /*#__PURE__*/cloneElement(defaultIcon, {
    color: 'icon-primary-default',
    size: iconSize
  });
}